import React from 'react';

const DownloadIcon = ({
    width = 40,
    height = 40,
    fill = 'black',
    stroke = 'none',
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20 25.9617L14.1017 20.065L15.2817 18.865L19.1667 22.75V8.33337H20.8333V22.75L24.7167 18.8667L25.8983 20.065L20 25.9617ZM11.0267 31.6667C10.2589 31.6667 9.61834 31.41 9.10501 30.8967C8.59168 30.3834 8.33445 29.7423 8.33334 28.9734V24.935H10V28.9734C10 29.23 10.1067 29.4656 10.32 29.68C10.5333 29.8945 10.7683 30.0011 11.025 30H28.975C29.2306 30 29.4656 29.8934 29.68 29.68C29.8945 29.4667 30.0011 29.2311 30 28.9734V24.935H31.6667V28.9734C31.6667 29.7411 31.41 30.3817 30.8967 30.895C30.3833 31.4084 29.7422 31.6656 28.9733 31.6667H11.0267Z"
                fill={fill}
                stroke={stroke}
            />
        </svg>
    );
};

export default DownloadIcon;
